import Price from "@kiwicom/frontend-common/records/Price"

import type {
  AxaUsInsuranceAncillaries,
  AxaUsInsuranceAncillariesInput,
} from "../../../scenes/BookingAncillary/consts/types"

export default (
  input?: AxaUsInsuranceAncillariesInput,
): AxaUsInsuranceAncillaries | null | undefined => {
  if (!input || input.length === 0) return null

  return input.map((value) => ({
    id: value.id,
    extraId: value.extra_id,
    orderState: value.order_state,
    status: value.status,
    refundableUntil: value.refundable_until,
    purchasedDate: value.purchased_date,
    items: value.items.map((pap) => ({
      id: pap.passenger_id,
      isActive: pap.is_active,
      level: pap.level,
      price: Price.fromServer(pap.price),
      universalId: pap.universal_id,
    })),
  }))
}
